// extracted by mini-css-extract-plugin
export default {"mainDiv":"login_mainDiv__uwGAk","form":"login_form__qa0M+","createBtn":"login_createBtn__CGlPR"};